import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

function authHeaders() {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");
  return { Authorization: `Bearer ${token}` };
}

const root = () => `${API_URL}/api/muestras-moodboards`;

export const createMuestrasMoodboard = async (muestraIds, meta = {}) => {
  const response = await axios.post(
    root(),
    { muestraIds, ...meta },
    { headers: authHeaders(), timeout: 120000 },
  );
  return response.data;
};

export const getMuestrasMoodboard = async (sessionId) => {
  const response = await axios.get(`${root()}/${sessionId}`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const deleteMuestrasMoodboard = async (sessionId) => {
  try {
    await axios.delete(`${root()}/${sessionId}`, {
      headers: authHeaders(),
    });
  } catch {
    /* best-effort cleanup */
  }
};

export const saveMuestrasMoodboardPages = async (
  sessionId,
  pages,
  { expectedUpdatedAt } = {},
) => {
  const response = await axios.patch(
    `${root()}/${sessionId}/pages`,
    {
      PagesJson: pages,
      ...(expectedUpdatedAt ? { ExpectedUpdatedAt: expectedUpdatedAt } : {}),
    },
    { headers: authHeaders() },
  );
  return response.data;
};

export const updateMuestrasMoodboard = async (sessionId, payload) => {
  const response = await axios.patch(`${root()}/${sessionId}`, payload, {
    headers: authHeaders(),
  });
  return response.data;
};

export const getMuestrasMoodboardPool = async () => ({
  searches: [],
  items: [],
});

export const addMuestrasMoodboardAssets = async (
  sessionId,
  { files = [] } = {},
) => {
  const form = new FormData();
  for (const file of files) form.append("files", file);
  const response = await axios.post(`${root()}/${sessionId}/assets`, form, {
    headers: { ...authHeaders(), "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const addMuestrasToMoodboardSession = async (sessionId, muestraIds) => {
  const response = await axios.post(
    `${root()}/${sessionId}/add-muestras`,
    { muestraIds },
    { headers: authHeaders(), timeout: 120000 },
  );
  return response.data;
};

export const deleteMuestrasMoodboardAsset = async (sessionId, assetId) => {
  const response = await axios.delete(
    `${root()}/${sessionId}/assets/${assetId}`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const removeBgMuestrasMoodboardAsset = async (sessionId, assetId) => {
  const response = await axios.post(
    `${root()}/${sessionId}/assets/${assetId}/remove-bg`,
    { replaceInPages: true },
    { headers: authHeaders(), timeout: 130000 },
  );
  return response.data;
};

export const contourStrokeMuestrasMoodboardAsset = async (
  sessionId,
  assetId,
  { width = 6, color = "#000000" } = {},
) => {
  const response = await axios.post(
    `${root()}/${sessionId}/assets/${assetId}/contour-stroke`,
    { width, color, replaceInPages: true },
    { headers: authHeaders(), timeout: 60000 },
  );
  return response.data;
};

export const cropMuestrasMoodboardAsset = async (sessionId, assetId, rect) => {
  const response = await axios.post(
    `${root()}/${sessionId}/assets/${assetId}/crop`,
    { ...rect, replaceInPages: true },
    { headers: authHeaders(), timeout: 60000 },
  );
  return response.data;
};

export const autoMuestrasMoodboardPages = async (sessionId) => {
  const response = await axios.post(
    `${root()}/${sessionId}/pages/auto`,
    {},
    { headers: authHeaders() },
  );
  return response.data;
};

export const exportMuestrasMoodboardPdf = async (sessionId, body = {}) => {
  const response = await axios.post(
    `${root()}/${sessionId}/export-pdf`,
    { pageIndexes: body.pageIndexes },
    { headers: authHeaders(), timeout: 180000 },
  );
  return response.data;
};

export const fetchMuestrasMoodboardAssetBlobUrl = async (
  sessionId,
  assetId,
) => {
  const response = await axios.get(
    `${root()}/${sessionId}/assets/${assetId}/file`,
    { headers: authHeaders(), responseType: "blob" },
  );
  return URL.createObjectURL(response.data);
};

export function createMuestrasMoodboardApi() {
  return {
    getById: getMuestrasMoodboard,
    getPool: getMuestrasMoodboardPool,
    savePages: saveMuestrasMoodboardPages,
    update: updateMuestrasMoodboard,
    removeBg: removeBgMuestrasMoodboardAsset,
    contourStroke: contourStrokeMuestrasMoodboardAsset,
    crop: cropMuestrasMoodboardAsset,
    autoPages: autoMuestrasMoodboardPages,
    addAssets: addMuestrasMoodboardAssets,
    deleteAsset: deleteMuestrasMoodboardAsset,
    exportPdf: exportMuestrasMoodboardPdf,
    exportBody:
      "Se descarga el PDF en tu ordenador. Este moodboard no se guarda en el servidor.",
  };
}
